<template lang="pug">
.confirm-plan-change-modal
  b-modal(ref="modal" v-model="_value" size="lg" no-close-on-backdrop no-close-on-esc hide-header
    @ok="update" @cancel="cancel")
    .confirm-plan-change-modal-body
      .confirm-title {{ requestPlanName }} にプランを変更しますが、よろしいですか？
      .confirm
        .message プラン変更前に以下をご確認ください。
        ul.confirm-list(v-if="currentPlanType == 0")
          li プラン変更は、お客様がプラン変更処理を行った日から適用されます。
          li プラン変更が行われた場合、その翌月より変更後のプランに係る本サービスの料金が適用されます。
          li 無料期間終了後は無料プラン（フリー）に戻すことは出来ません。
        ul.confirm-list(v-else)
          li プラン変更は、お客様がプラン変更処理を行った日から適用されます。
          li プラン変更が行われた場合、その翌月より変更後のプランに係る本サービスの料金が適用されます。
        label
          input(type="checkbox" @click="checked = !checked")
          span 同意する

    div(slot="modal-footer" slot-scope="{ ok, cancel }")
      button.btn.modal-ok-btn(v-if="checked" type="button" @click="ok()") OK
      button.btn.modal-ok-btn.disable(v-else type="button" disabled) OK
      button.btn.modal-cancel-btn(type="button" @click="cancel()") キャンセル
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import { PlanType } from "@/commons/services/Plans";

/**
 * プラン変更確認モーダル
 */
@Component
export default class PlanChangeModal extends Vue {
  /** モーダル表示可否 */
  @Prop({ required: true })
  value!: boolean;

  /** 現在のプラン */
  @Prop({ required: true, type: Number })
  private currentPlanType!: PlanType;

  /** 変更依頼するプラン名 */
  @Prop({ required: true, type: String })
  private requestPlanName!: String;

  /** 更新対象名 */
  public checked: boolean = false;

  get _value(): boolean {
    return this.value;
  }

  set _value(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }

  /**
   * OKボタン押下イベント
   */
  public update(): void {
    this.$emit("register");
    this.checked = false;

    return;
  }

  /**
   * キャンセルボタン押下イベント
   */
  public cancel(): void {
    this.$emit("cancel");
    this.checked = false;

    return;
  }
}
</script>
